module.exports = __webpack_public_path__ + "static/media/bg-conservatories.54323ddb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-conservatories.jpg
// module id = 641
// module chunks = 0